/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, ReactNode, SVGAttributes } from "react";
import { Dayjs } from "dayjs";
import { feedbackOptions } from "@/data/static/agenda";
import ROUTES from "@/config/routes.ts";

type Only<T, K extends keyof T> = Pick<T, K>;

export type ILanguages = "it" | "es" | "en" | "de" | "fr" | "pt";

export interface RouteObject {
  path: string;
  exact?: boolean;
  element: JSX.Element;
  children?: RouteObject[];
  isPrivate?: boolean;
}

export interface LoginUserInput {
  email: string;
  password: string;
}

export interface PasswordResetUserInput {
  email: string;
}

export interface   VerifyPasswordTokenUserInputResponse{
  status: number;
  message: string;
  items?: any[];
  item?: any;
}

export interface NewPasswordUserInput {
  token: string;
  password: string;
}

export interface NewPasswordFormInput {
  password: string;
  confirmPassword: string;
}


export interface NewPasswordBetaPayload {
  password: string;
  token: string;
}

export interface PasswordResetResponse extends DefaultResponse {
  item: { message: string };
}

export interface UpsellingRequest {
  response: string;
}

export interface DefaultResponse {
  status: number;
  message: string;
}

export interface OnboardingItem {
  name: string;
  token: string;
  timer: number;
  typeof: string;
  labels: { [key: string]: string };
  completed: boolean;
  description: string;
  description_labels: { [key: string]: string };
}

export interface CategoryState {
  name: string;
  words: string[];
}

interface QuizItem {
  level: string;
  points: number;
}

interface CRMUpsellingUpdateItem {
  date: string;
  admin: string;
  status: string;
  owned_by: string;
}

interface MeetItem {
  id: string;
  end: string;
  link: string;
  start: string;
  calendar: string;
  pacchetto: string;
  english_lvl: string;
  interviewer: string;
  newStartingMonth: string;
}

interface CRMUpsellingMeetingItem {
  meet: MeetItem[];
  summary: string;
}

interface CRMUpsellingItem {
  status: string;
  updates: CRMUpsellingUpdateItem[];
  owned_by: string;
  comments: string | null;
  meetings: CRMUpsellingMeetingItem;
  token_user: string;
  meeting_date: string;
  meeting_status: string | null;
  convert_status: string | null;
  email_progress: string | null;
  date_email_sent: string | null;
  unsubscribe_email: string | null;
}

export interface UserPaymentItem {
  id: number;
  amount: number;
  paid_for: string;
  type: string;
  data: string;
  token_user: string;
  url_driver: string | null;
  is_refunded: boolean | null;
  refunded_date: string | null;
  refund_payment_id: string | null;
  product_id: number | null;
  quantity: number;
  is_pending: boolean;
  product: ProductItem;
  data_rimborso: string | null;
  refund_det: string | null;
  fleg_rimborsato: boolean | null;
  via: string | null;
  count: number | null;
  deleted_at: string | null;
}

interface ChangeEventByMonthItem {
  month: string;
  kickoff_date: string;
  changed_events: number;
}

export type TUserLang = "en" | "es" | "it" | "fr" | "de" | "pt";

export interface LoginUserItem {
  id: number;
  zipcode: string | null;
  first_name: string;
  phone: string | null;
  quiz: QuizItem | null;
  lang: TUserLang | null;
  lang_from_phone: TUserLang | null;
  email: string;
  token: string;
  city: string | null;
  last_name: string;
  payments: Payment[];
  products: ProductItem[];
  user_hash: string;
  address: string | null;
  settings?: { isBeta?: boolean };
  created_at: string;
  onboarding: boolean | null;
  start_month: string | null;
  nps_feedback: number | null;
  crm_upselling: CRMUpsellingItem | null;
  created_account: boolean;
  birth_date: string | null;
  english_level: string | null;
  max_change_event: number;
  tutor_one_to_one: string | null;
  diploma_unlocked: boolean | null;
  count_change_events: number;
  unlock_count_exercises: number | null;
  timezone? : string | null;
  changed_events_by_month: ChangeEventByMonthItem[] | null;
  check_user_booking_ielts: Array<{
    user_id: number;
    created_at: string;
    booking_pic: string;
  }> | null;
}

export interface Pivot {
  token_user: string;
  token_percorso: string;
}

export interface UpdateTimezoneInput {
  token: string;
  timezone: string;
}

export enum MaterialsType {
  SPEAKING = "Speaking",
  GRAMMAR = "Grammar",
  IELTS = "IELTS",
}

export interface LoginUserResponse {
  user: LoginUserItem;
  token: string;
  hasIelts: boolean;
  hasSpeaking: boolean;
  hasWritingCorrection: boolean;
  onboarding: OnboardingItem[];
  permissions: string[];
  kickoff_date: string;
  subDaysBookExam: number;
  current_kickoff: string | null;
  end_kickoff_date: string | null;
  next_kickoff_date: string | null;
  date_active_book_exam: string | null;
  months_writing_correction: MonthsCorrectionItem[];
}

export interface MonthsCorrectionItem {
  end_date: string;
  start_date: string;
  count_corrections: number;
  count_booked_corrections: number;
  hours_writing_correction: number;
}

export interface AuthResponse extends DefaultResponse {
  item: LoginUserResponse;
}

export interface DefaultErrorResponse {
  status: number;
  message: string;
}
export interface User extends DefaultResponse {
  item: LoginUserResponse;
}

interface StringaData {
  id: string;
  status: number;
}
export interface UserAvailabilityArrayData {
  Stringa: StringaData[];
}
export interface UserAvailabilityData {
  id: number;
  array: UserAvailabilityArrayData[];
  token_user: string;
  date_range: string;
  user_choice: string | null;
}
export interface UserAvailability {
  date: string[];
  recent: UserAvailabilityArrayData[] | null;
  noLimit: boolean;
  success: boolean;
  deadline: string;
  refMonth: string;
  userData: UserAvailabilityArrayData[] | null;
  draftDate: string[];
  refMonthIdx: number;
  isSuspended: boolean;
  isLastMonth: boolean;
  draftUserData: UserAvailabilityArrayData[] | null;
  hasAvailability: boolean;
  hasOldAvailabilities: boolean;
  isIntoRangeForInsert: boolean;
  isIntoRangeSuspended: boolean;
  isIntoRangeCurrentProduct: boolean;
}
export interface UserAvailabilities extends DefaultResponse {
  item: UserAvailability;
}

export interface UserIniPaymentData {
  data: string;
  token: string;
  total: number;
  amount: number;
  paid_total: number;
  product_token: string | null;
  original_price: number;
  original_price_iva: number;
  original_price_no_iva: number;
}
interface UserIniPayment {
  paid_total: boolean;
  payment_data: UserIniPaymentData | null;
}

export interface UserIniPayments extends DefaultResponse {
  item: UserIniPayment;
}

export interface SidebarItem {
  type: string;
  name: string;
  value: string;
  path: (typeof ROUTES)[keyof typeof ROUTES];
  Icon: FC<SVGAttributes<NonNullable<unknown>>> | null;
  isDev?: boolean;
}

export interface PageHeaderProps {
  title: string | ReactNode;
  button?: React.ReactNode;
  subtitle?: string | ReactNode;
  className?: string;
  showButton?: boolean;
  titleClassName?: string;
  subtitleClassName?: string;
}

export interface SchemaValidationItem {
  name: string;
  type: string;
  min?: number;
  max?: number;
  enum?: string[];
  message: string;
  default?: never;
  pattern?: RegExp;
  required: boolean;
  nullable?: boolean;
  minLength?: number;
  maxLength?: number;
}

export interface ProductLinks {
  terms: { [key: string]: string };
  policy: string;
}

export interface ProductCourseStructure {
  ielts: number;
  grammar: number;
  writing: number;
  speaking: number;
  one_to_one: number;
  linguaskill: number;
}

export type ProductCourseType =
  | "speaking"
  | "ielts"
  | "linguaskill"
  | "grammar"
  | "one_to_one"
  | "writing";

export interface IObLangauges {
  it?: string;
  es?: string;
  en?: string;
  de?: string;
  fr?: string;
  pt?: string;
}

export interface ProductCourseInfo {
  months: number;
  course_name: string;
  link_onboarding: string | IObLangauges;
  course_structure: ProductCourseStructure[];
}

export interface ProductItem {
  id: number;
  token: string;
  price: number;
  timer: number;
  links: ProductLinks;
  tutoring: boolean;
  product_tag: string;
  course_info: ProductCourseInfo;
  percorso_token: string;
  enable_quantity: boolean;
  terms_cond_locales: ProductLinks;
  created_at: string;
  pivot: {
    user_id: number | null;
    end_date: string | null;
    product_id: number | null;
    start_date: string | null;
    diploma_unlocked: number | null;
  };
}

export interface UserProducts extends DefaultResponse {
  item?: [];
  items?: ProductItem[];
}

export interface OneToOneCredits extends DefaultResponse {
  item: {
    count_credits: number;
    is_first_one_to_one: boolean;
  };
}

export interface NotificationMetadata {
  id: number;
  seen: boolean;
}

export interface UserNotificationItem {
  id: number;
  body: string;
  seen: boolean;
  title: string;
  token: string;
  isNew: number;
  action: NotificationType;
  variant: string;
  fromNow: string;
  metadata: NotificationMetadata[];
  created_at: string;
  isNewClassReport: number;
  notificationType: number;
}

export interface UserNotificationPaginator extends DefaultResponse {
  items: UserNotificationItem[];
}

export interface MaterialOptionProps {
  path: string;
  label: string;
  hasNew: boolean;
  description: string;
}

export interface EventMaterialItem {
  id: number;
  name: string;
  type: string;
  token: string;
  lesson: string;
  resource: string;
  material_type: string;
  images?: string[] | null;
}

export interface EventMaterialUserEventItem {
  first_name: string;
  token: string;
  pivot: { event_id: number; user_token: string };
  last_name: string;
  access_date: string | null;
  is_logged_in: boolean;
}

export interface FeedbackUserItem {
  punto: number;
  rating: number;
  hidden: boolean;
  id_user: number;
  id_evento: number;
  improvements: string;
  rating_tutor: number;
  rating_topic: number;
  last_feedback: string;
  first_feedback: string;
}
export interface EventsItem {
  livello: string;
  id: number;
  link_meet: string;
  link_video: string | null;
  nome_visualizzato: string;
  data: string;
  ora: string;
  isDeleted?: boolean;
  ora_fine: string;
  titolo: string;
  titolo_argomento: string | null;
  descrizione: string;
  descrizione_argomento: string | null;
  tutor_token: string;
  type: string;
  canJoin: boolean;
  colSpan?: number;
  tutors: {
    first_name: string;
    last_name: string;
    profile_pic: string;
    token: string;
  };
  feedback_user: FeedbackUserItem[];
  materials: EventMaterialItem[];
  user_events: EventMaterialUserEventItem[];
  pivot: {
    access_date: null | string;
  };
  convertedStartTime: moment.Moment;
  convertedEndTime: moment.Moment;
}

export interface PlatformDetails {
  ip: string;
  location: {
    city: string;
    state: string;
    country: string;
    country_code: string;
    continent: string;
    continent_code: string;
  };
}

export interface UserLoginActivity {
  id: number;
  user_token: string;
  platform: string;
  platform_details: PlatformDetails;
  login_status: boolean;
  login_date: string;
  login_time: string;
}

export interface SlotType {
  ora_fine?: string;
  ora?: string;
  duration?: number;
  colSpan?: number;
  slotStyle?: string;
  rowStyle?: string;
  childEvents?: ModifiedEventsItem[];
  columnStyle?: string;
  [key: string]: unknown; // Additional properties
}
export interface AgendaEvent extends EventsItem {
  colSpan?: number;
  date: Dayjs;
  ora_fine: string;
  ora: string;
  startDate?: Dayjs;
  endDate?: Dayjs;
  descrizione: string;
  title?: string;
  exercises_token?: string;
  exercise_name?: string;
  slotStyle?: string;
  exercises?: never[];
  id: number;
  tutor_token: string;
  exercise_token?: string;
  user_events: EventMaterialUserEventItem[];
  materials: EventMaterialItem[];
  report: boolean;
  name: string;
  users: never[];
}

export interface MaterialsItem {
  subtype: string;
  category: string[];
  id: number;
  name: string;
  created_at: string;
  token: string;
  type: string;
  is_deleted: boolean | number;
  lesson: string;
  lessonOf: string;
  material_type: string;
  resource: string;
  isNew: boolean | null;
  precourse: boolean | null;
  images: string[] | null;
}

export interface EventMaterials extends DefaultResponse {
  item: {
    events: EventsItem[];
    materials: MaterialsItem[];
    lessons_attended: number;
    percentage_attended: number;
  };
}

export interface QuestionItem {
  [key: string]: {
    question_type: string;
    correct_answer: string;
  };
}

export interface UserSubmitItem {
  [key: string]:
    | {
        user_answer: string;
        correct_answer: string;
      }
    | string;
}

export interface ExerciseCorrectionItem {
  type: ExerciseOptionTypes;
  score: number;
  total: number;
}

export interface ExerciseMatchingOptionsItem {
  id: number;
  course_exercises_id: number;
  statement: string;
  type: string;
  correct_answer: string;
}

export interface ExerciseTrueOrFalseItem {
  id: number;
  course_exercises_id: number;
  question: string;
  type: string;
  explanation: string | null;
}

export interface ExerciseGroupingsItem {
  id: number;
  course_exercises_id: number;
  word: string;
  category: string;
}

export interface CorrectionResult {
  word: string;
  isCorrect: boolean;
}

export interface ExerciseDefinitionsItem {
  id: number;
  course_exercises_id: number;
  definition: string;
  dictionary_id: string;
  value: string;
  recycling: string;
}

export type ExerciseCategoryData =
  | ExerciseCorrectionItem
  | ExerciseMatchingOptionsItem
  | ExerciseTrueOrFalseItem
  | ExerciseGroupingsItem
  | ExerciseDefinitionsItem;

export interface ExerciseTODO {
  duration: number;
  id: number;
  modality: string;
  type: string;
  token: string;
  name: string;
  audio_file: string;
  img_file: string;
  definitions: ExerciseDefinitionsItem[];
  text: string;
  true_false: ExerciseTrueOrFalseItem[];
  gap_fill: ExerciseMatchingOptionsItem[]; // confirm the correct interface
  matching_option: ExerciseMatchingOptionsItem[];
  groupings: ExerciseGroupingsItem[];
  multiple_choice: Question[];
  timer: number;
  count: number | null;
  questions: QuestionItem;
  files: ExerciseFiles;
  created_at: string;
  updated_at: string;
  event_date: string;
  is_precourse: number;
  lang: TUserLang;
  english_level: string;
  toDoBy: string;
  hasDeadLine: number;
  has_deadline: number;
  exercises_statuses: ExerciseStatuses;
  exercises_progress: ExerciseProgress;
  pivot: {
    correction: string;
    user_token: string;
    event_id: number;
    vote: string;
  };
  isNew: boolean | null;
  isPot: boolean | null;
  category: string;
}

interface PivotData {
  user_id: number;
  course_exercise_id: number;
  info: string;
  correction: string;
  vote: string | null;
  created_at: string;
}

export interface ExerciseDONE {
  id: number;
  user_id: number;
  token: string;
  token_ex: string;
  timer: number | null;
  test_name: string;
  user_score: string | null;
  user_submit: UserSubmitItem | null;
  raw_text_answer: string;
  essaychecker_result: EssaycheckerResponse[] | string;
  data: string;
  type: string;
  modality: string;
  corrected: boolean | null;
  correction_data: string | null;
  ex_id: number | null;
  files: ExerciseFiles;
  questions: QuestionItem;
  ielts_score?: number;
  is_precourse: number;
  lang: TUserLang;
  english_level: string;
  isNew: boolean | null;
  isPot: boolean | null;
  pivot: PivotData;
  name: string;
  count: number;
  hasDeadLine: number;
  has_deadline: number;
  duration: number;
  audio_file: string;
  img_file: string;
  definitions: ExerciseDefinitionsItem[];
  exercises_progress: ExerciseProgress;
  text: string;
  true_false: ExerciseTrueOrFalseItem[];
  gap_fill: ExerciseMatchingOptionsItem[]; // confirm the correct interface
  matching_option: ExerciseMatchingOptionsItem[];
  groupings: ExerciseGroupingsItem[];
  multiple_choice: Question[];
  category: string;
}

export interface EssaycheckerResponse {
  id: string;
  title: string;
  score: string;
  desc: string;
}

export interface CorrectionResults {
  [key: string]:
    | {
        question_type?: string;
        user_answer?: string;
        correct_answer: string;
      }
    | string;
}

export interface CorrectionQResults {
  question_type?: string;
  user_answer?: string;
  correct_answer: string;
}

export interface ExerciseResult extends ExerciseDONE {
  result: CorrectionResults;
  ielts_score: number;
}

export type Exercise = ExerciseTODO | ExerciseDONE;

export interface ExerciseAudioFile {
  path: string;
  darkWave: string;
  lightWave: string;
  duration: string;
}

export interface ExerciseFiles {
  media: string;
  audio?: string | ExerciseAudioFile;
  images?: string[][];
  ["q-images"]?: string[][];
}

export interface CorrectionBookItem {
  month: string;
  corrections: number;
  type: string;
  pivot: {
    user_token: string;
    event_id: number;
  };
}

export interface CorrectionItem extends CorrectionBookItem {
  access_date: string;
}

export interface IUserAnswers {
  [x: string]: {
    option_id: number;
    question_id: number;
    text_answer: string;
    exercise_type: string;
  };
}

export interface UserExerciseItem {
  done: ExerciseDONE[];
  toDo: ExerciseTODO[];
  isPot?: boolean | null;
  userAnswers: IUserAnswers;
  count_corrections: CorrectionItem[];
  count_booked_corrections: CorrectionBookItem[];
  exercises_done_into_current_range_product: number;
}

export interface UserExercises extends DefaultResponse {
  items?: UserExerciseItem;
  item?: UserExerciseItem;
  status: number;
  message: string;
}

interface BookedIELTSItem {
  id: number;
  token_user: string;
  location: string;
  date_exam: string;
  method: string;
  link_exam: string;
}

export interface BookedIELTS extends DefaultResponse {
  item: BookedIELTSItem | null;
}

export enum NotificationType {
  INFO = "info",
  LESSONS = "lessons",
  WRITING = "writing",
  ADD_EXERCISES = "add_exercises",
  ADD_MATERIALS = "add_materials",
  REFERRAL = "referral",
  UPSELLING = "upselling",
  ADD_EVENTS = "add_events",
  ADD_CLASS_REPORT = "add_class_report",
  AVAILABILITY = "availability",
}

export interface UserOnboardingSaveInput {
  token: string;
  timer: number;
  completed: boolean;
}

export interface OnEndedHandlerProps {
  timer: number;
  duration: number;
  completed: boolean;
}

export interface FilterState {
  types: string[];
  subtypes: string[];
}

export interface GlobalState {
  backgroundClass: string;
  sidebarContent: ReactNode | null;
  showAuthBar: boolean;
  showSideBar?: boolean;
  isPot?: boolean;
  containerize: boolean;
  filters: FilterState;
}

export interface BookExamUserInput {
  location: string;
  token_user: string;
  date_exam: string;
  method: string;
}

export interface BookExamItem {
  id: number;
  location: string;
  token_user: string;
  date_exam: string;
  method: string;
  link_exam?: string;
  booked: boolean;
  created_at: string;
  updated_at: string;
}
export interface BookExamResponse extends DefaultResponse {
  item: BookExamItem;
}

export interface ReferralItem {
  id: string;
  token_user: string;
  token_new_user: string;
  meeting_booked: boolean;
  converted: boolean;
  redeemed: boolean;
  created_at: string;
  updated_at: string;
}

export interface ReferralResponse extends DefaultResponse {
  items: ReferralItem[] | null;
}

export interface DownloadInvoiceInput {
  token: string;
  idInvoice: number;
}

export type DownloadInvoiceResponse =
  | {
      message: string;
    }
  | {
      message: string;
      error: string;
    }
  | string;

export interface CalendarListParams {
  parse: boolean;
  interval: string[];
  default: boolean;
  isUpselling: boolean;
  token: string;
}

export interface CalenderItem {
  date: string;
  calendar: string;
  calendar_id: string;
}

export interface AvailabilitySlot {
  value: { day: string; time: string };
  isSelected: boolean;
  id: string;
}

export const AvailabilitySlotProgress = {
  START: 0,
  CONFIRM: 1,
  COMPLETE: 2,
};

export interface TutorAvailabilityParams {
  user_token: string;
  tutor_role: string;
  tutor_token: string | null;
  half_time: boolean;
  time_distance: number;
}

interface AvailabilityAvailabilitesItem {
  id: number;
  token_user: string;
  array: UserAvailabilityArrayData[];
  data_range: string;
  user_choice: string | null;
  created_at: string;
  updated_at: string;
}

interface AvailabilityTutorItem {
  token: string;
  first_name: string;
  email: string;
  events: string[];
  availabilities: AvailabilityAvailabilitesItem[];
}

interface AllDatesItem {
  date: string;
  tutor_token: string;
}

export interface AvailableDaysItem {
  date: string;
  tutor: string;
}

export interface TopicsOneToOneDone {
  id: number;
  tutor_token: string;
  titolo: string;
  descrizione: string;
  data: string;
  ora: string;
}

export interface TutorAvailabilityItem {
  all_events: string[];
  user_events: string[];
  tutor: AvailabilityTutorItem[];
  all_dates: AllDatesItem[];
  available_days: AvailableDaysItem[];
  topics_one_to_one_done: TopicsOneToOneDone[];
}

export interface AvailableSpeakingClass {
  id: number;
  tutor_token: string;
  data: string;
  ora: string;
  ora_fine: string;
  type: string;
  titolo: string;
  descrizione: string;
  tutors: {
    id: number;
    profile_pic: string;
    first_name: string;
    last_name: string;
    token: string;
    role: string;
  };
  user_events: unknown[];
}

export interface SpeakingClassesAvailable {
  item: {
    events: {
      [date: string]: AvailableSpeakingClass[];
    };
  };
}

export interface BookSpeakingClassesInput {
  event_ids: number[];
  user_token: string;
}

export interface InfoTutorOneToOne {
  available_dates: string[];
  tutor: {
    token: string;
    email: string;
    first_name: string;
    profile_pic: string;
  };
}

export interface InfoPreviousTutorOneToOne {
  available_dates: string[];
  tutor: {
    name: string;
    image: string;
    token: string;
  };
}

export interface TutorOneToOneAvailabilityItem {
  item: { current_tutor: InfoTutorOneToOne; tutors: InfoTutorOneToOne[] };
}

export interface NewTutorAvailabilityItem {
  items: AvailableDaysItem[];
}

export interface TutorOneToOneAvailabilityParams {
  tutor_role: string;
  half_time: boolean;
  time_distance: number;
}

export interface OneToOneEventDone {
  data: string;
  descrizione: string;
  id: number;
  ora: string;
  titolo: string;
  tutor_token: string;
}

export interface UserOneToOneTopicsDone {
  item: OneToOneEventDone[];
}

export interface UserOneToOneCredits extends DefaultResponse {
  item: {
    count_credits: number;
    is_first_one_to_one: boolean;
  };
}

export interface BookOneToOneOutput {
  item: {
    data: string;
    descrizione: string;
    english_lvl: string;
    id: number;
    link_meet: string;
    livello: string;
    nome_visualizzato: string;
    ora: string;
    ora_fine: string;
    titolo: string;
    titolo_argomento: string;
    tutor_token: string;
    type: string;
  };
}

export interface BookOneToOneInput {
  tutor_token: string;
  user_token: string;
  data: string | null;
  ora: string | null;
  ora_fine: string;
  titolo_argomento: string;
  descrizione: string;
  id_material: number | null;
}

export interface BookOneToOneResponse extends DefaultResponse {
  item: EventsItem;
}

export interface BookDiplomaRequestInput {
  attendees: string[];
  user_token: string;
  start: string;
  summary: string;
  calendar_id: string;
  calendar: string[];
  isUpselling: boolean;
  newStatus: string;
}

export interface BookDiplomaRequestResponse {
  success: boolean;
}

export interface UpdateUserAvailabilityInput {
  data_range: string;
  array: string;
}

export interface DownloadICS {
  data: string;
  link_meet: string;
  titolo: string;
  ora: string;
  ora_fine: string;
  id: number;
  description: string;
}

export interface GetChangedEventsInput {
  user_token: string;
  event_id: number;
  livello: string;
}

export interface GetChangedEventInput {
  expire: number;
  event: number;
  events: number[];
  user: string;
}

export interface ChangeEventItem {
  id: number;
  data: string;
  time: string;
  duration: number;
}

export interface GetChangedEventsResponse {
  current_event: EventsItem;
  selected_events: EventsItem[];
  user: Only<
    LoginUserItem,
    "token" | "first_name" | "changed_events_by_month" | "email"
  >;
  title_formatted: string;
}

export interface GetChangedEventResponse {
  event: ChangeEventItem;
  events: ChangeEventItem[];
  status?: boolean;
}

export interface SelectedEventsProps {
  date: string;
  eventId: number;
}

export interface SetChangeEventInput {
  newEvent: number;
  userToken: string;
  event: number;
  update_counter?: boolean;
}

export interface SetChangeEventResponse {
  status: boolean;
  events: EventsItem[];
}

export enum EventTypes {
  Speaking = "Speaking",
  IELTS = "IELTS",
  MockTest = "Mock test",
  WritingCorrection = "Correction",
  Grammar = "Grammar",
  Past = "Past",
  Unfilled = "unfilled",
  Substitute = "Substitute",
}

export interface ModifiedEventsItem extends EventsItem {
  colSpan: number;
  slotStyle?: string;
}

export interface FeedbackProps {
  id_user: number;
  id_evento: number;
  rating: {
    tutor: number;
    topicAndOrganization: number;
  };
}

export interface AgendaFeedbackState {
  idEvent: number;
  date: Date | Dayjs;
  tutor_nome: string;
  title: string;
  type: keyof (typeof feedbackOptions)["Topic and organization"];
}

export interface FeedbackInput extends FeedbackProps {
  first_feedback: string;
  improvements?: string;
  last_feedback?: string;
}

export interface FeedbackResponse {
  status: string;
  data: FeedbackUserItem;
}

export interface CorrectExerciseInput {
  id: number;
  token_ex: string;
  user_submit: string;
  test_name: string;
  type: string;
  timer?: string;
}

export interface CorrectExerciseResponse {
  user_id: number;
  token_ex: string;
  timer: number;
  test_name: string;
  user_score: number;
  user_submit: UserSubmitItem;
  data: string;
  type: string;
  corrected: boolean;
  correction_data: string;
  ielts_score: number;
  files: ExerciseFiles;
}

export interface BookMockTestInput {
  user_id: number;
  user_token: string;
  tutor_token: string;
  data: string;
  ora: string;
  ora_fine: string;
  token_ex: string;
  type: string;
}

export interface BookMockTestResponse extends DefaultResponse {
  item: EventsItem;
}

export interface BookLiveCorrectionInput {
  user_id: number;
  user_token: string;
  tutor_token: string;
  data: string;
  ora: string;
  ora_fine: string;
  type: string;
}

export interface BookLiveCorrectionResponse extends DefaultResponse {
  item: EventsItem;
}

export interface BookExamsSteps {
  icon: FC<SVGAttributes<NonNullable<unknown>>>;
  text: JSX.Element;
}

export interface BookExamsToDo {
  icon: FC<SVGAttributes<NonNullable<unknown>>>;
  text: string;
}

export interface SortedProducts {
  label: string;
  value: number | string;
  isNew: boolean;
  startDate: string;
}

export interface ClassTutor {
  id: number;
  profile_pic: string;
  first_name: string;
  last_name: string;
}

export interface ClassEvent {
  id: number;
  data: string;
  ora: string;
  link_video?: string | null;
  type?: string;
  titolo_argomento: string;
}

export interface ClassReportsItem {
  id: number;
  excels_in: string[] | null;
  suggestions: string | null;
  event_id: number;
  tutor_id: number;
  user_id: number;
  tutor: ClassTutor;
  event: ClassEvent;
}

export interface NavigationState {
  isCR: boolean;
  linkVideo?: string;
  typeCR?: string;
  tutorPic?: string;
  tutorName?: string;
  tutorSurname?: string;
}

export interface ClassReports extends DefaultResponse {
  items: ClassReportsItem[];
}

export interface IniDates {
  [key: string]: {
    label: string;
    value: string;
  };
}

export interface FindUserResponse {
  first_name: string;
  last_name: string;
  email: string;
  token: string;
  start_month: string;
  created_account: string;
  lang: ILanguages;
  init_dates: IniDates[];
  payments: UserPaymentItem[];
}

export interface FindUser extends DefaultResponse {
  item: FindUserResponse;
}

export enum MessageEnum {
  COURSE_START,
  MISSED_LAST_WEEK,
  FIRST_WEEK_COMPLETE,
  RETURN_AFTER_MISSING_WEEK,
  MONTH_TO_COMPLETION,
  DEFAULT,
  COURSE_COMPLETED,
  COURSE_START_1_TO_1,
}

export interface LoginActivity extends DefaultErrorResponse {
  item: UserLoginActivity;
}

export interface RegisterUserInput {
  lang: string;
  birth_date: string;
  password: string;
  confirm_password: string;
  email: string;
  profession: string;
  referer: string;
  start_month: string | null;
  sector?: string;
  token: string;
}

export interface FeedbackRatingInput {
  token: string;
  nps_feedback: number;
  nps_comment: string;
}

export interface FeedbackRatingResponse extends LoginUserResponse {}

export interface QueryOptions {
  enabled?: boolean;
  staleTime?: number;
  refetchOnMount?: boolean;
  refetchOnReconnect?: boolean;
  refetchOnWindowFocus?: boolean;
  refetchInterval?: number;
  refetchIntervalInBackground?: boolean;
  retry?: number;
  retryDelay?: number;
}

export interface ExerciseComponentMap {
  multipleChoice: MultipleChoiceTrueFalse[];
  matchingOption: MatchingOptionGapFill[];
  trueOrFalse: MultipleChoiceTrueFalse[];
  gapFill: MatchingOptionGapFill[];
  grouping: Grouping[];
}

export interface ExercisesContainerProps {
  exercise: ExerciseTODO | ExerciseDONE;
}

export interface WarmUpProps {
  exercise: ExerciseTODO | ExerciseDONE | undefined;
  inProgress: boolean;
  isDone: boolean;
}

export interface ExerciseOption {
  id: number;
  multiple_choice_true_false_id: number;
  option: string;
  is_correct: number;
  explanation: string | null;
}

export interface MultipleChoiceTrueFalse {
  id: number;
  course_exercises_id: number;
  question: string;
  type: string;
  options: ExerciseOption[];
}

export interface MatchingOptionGapFill {
  id: number;
  course_exercises_id: number;
  statement: string;
  type: string;
  correct_answer: string;
}

export interface Grouping {
  id: number;
  course_exercises_id: number;
  word: string;
  category: string;
}

export interface Definition {
  id: number;
  value: string;
  definition: string;
  pivot: {
    course_exercises_id: number;
    dictionary_id: number;
  };
}

export interface RequestData {
  course_exercise_id?: number;
  question_id?: number;
  exercise_type?: ExerciseOptionTypes;
  text_answer?: string;
  option_id?: number;
  current_time?: number;
  exercise_results?: ExerciseResult[];
  average_score?: number;
  status?: string;
}

export interface ExerciseResult {
  type: string;
  score: number;
  total: number;
}

export interface GrammarExercise {
  id: number;
  name: string;
  type: string;
  duration: string;
  text: string;
  audio_file: null | string;
  img_file: null | string;
  created_at: string;
  updated_at: string;
  multiple_choice_true_false: MultipleChoiceTrueFalse[];
  matching_option_gap_fill: MatchingOptionGapFill[];
  groupings: Grouping[];
  definitions: Definition[];
}

export interface ExerciseStatusRequest {
  course_exercise_id?: number | undefined;
  status?: string;
}

export interface ExerciseProgressRequest {
  exercises: RequestData[];
  average_score: number;
  exercise_results: NewResult;
}

export interface ExerciseProgress {
  id: number;
  user_token: string;
  course_exercise_id: number;
  current_question_id: number;
  current_time: number;
  exercise_type: string;
  last_updated: string;
}

export interface ExerciseStatuses {
  id: number;
  course_exercise_id: number;
  user_token: string;
  status: string;
  created_at: string;
  updated_at: string;
}

export enum ExerciseOptionTypes {
  TrueFalse = "true_false",
  MultipleChoice = "multiple_choice",
  MatchingOption = "matching_option",
  GapFill = "gap_fill",
  Grouping = "groupings",
}

export interface IScoreBar {
  score: number;
  total: number;
  type: ExerciseOptionTypes;
}

export interface IOption {
  id: number;
  multiple_choice_true_false_id: number;
  option: string;
  is_correct: number;
}

export interface ITrueFalseQuestion {
  id: number;
  course_exercises_id: number;
  question: string;
  type: "true_false";
  explanation: string | null;
  options: IOption[];
}

export interface IGapFillQuestion {
  id: number;
  course_exercises_id: number;
  statement: string;
  type: "gap_fill";
  correct_answer: string;
}

export interface IGroupingQuestion {
  id: number;
  course_exercises_id: number;
  word: string;
  category: string;
}

export interface IDefinition {
  id: number;
  value: string;
  definition: string;
  pivot: {
    course_exercises_id: number;
    dictionary_id: number;
  };
}

export interface IExerciseProgress {
  id: number;
  user_token: string;
  course_exercise_id: number;
  current_question_id: number;
  exercise_type: string;
  current_time: number;
  last_updated: string;
}

export interface IExerciseStatus {
  id: number;
  course_exercise_id: number;
  user_token: string;
  status: string;
  created_at: string;
  updated_at: string;
}

export interface IPivotInfo {
  user_id: number;
  course_exercise_id: number;
  info: string;
  correction: string;
  vote: string;
  created_at: string;
}

export interface IGrammarExercise {
  id: number;
  name: string;
  modality: string;
  duration: string;
  text: string;
  audio_file: string | null;
  img_file: string;
  created_at: string;
  updated_at: string;
  category: string | null;
  has_deadline: number;
  lang: string | null;
  is_precourse: number;
  type: string | null;
  pivot: IPivotInfo;
  multiple_choice: any[];
  true_false: ITrueFalseQuestion[];
  matching_option: any[];
  gap_fill: IGapFillQuestion[];
  groupings: IGroupingQuestion[];
  definitions: ExerciseDefinitionsItem[];
  exercises_progress: IExerciseProgress[];
  exercises_statuses: IExerciseStatus[];
  isPot: boolean;
  questions: Record<
    string,
    {
      question_type: string;
      correct_answer: string;
    }
  >;
  userAnswers?: Record<string, string>;
  exerciseTrack?: string;
  audioUrl?: string;
  imageUrl?: string;
  files?: {
    media: string;
  };
}

export interface FeedbackRatingInput {
  token: string;
  nps_feedback: number;
  nps_comment: string;
}

export interface FeedbackRatingResponse extends LoginUserResponse {}

export interface EssayScoreAI {
  bandScore: number;
  achievement: number;
  coherenceCohension: number;
  lexicalResource: number;
  grammerAccuracy: number;
}

export interface SelectionProp {
  start_index: number;
  end_index: number;
}

export interface SelectionsProp {
  selections: SelectionProp[];
}

export type ExerciseCorrectionStages =
  | "selection"
  | "confirmation"
  | "finale"
  | "date"
  | "hour";

export type ITypes =
  | "speaking"
  | "correction"
  | "ielts"
  | "mocktest"
  | "grammar"
  | "Speaking"
  | "Correction"
  | "Ielts"
  | "Mocktest"
  | "Grammar";

export interface Payment {
  id: number;
  canView: number;
  product_id: number;
  token_user: string;
  amount: string;
  is_pending: boolean;
  paid_for: string;
  type: string;
  data: string;
  quantity: number;
  data_rimborso: string | null;
  refund_det: string | null;
  fleg_rimborsato: boolean | null;
  via: string | null;
  count: number | null;
  is_refunded: boolean | null;
  refunded_date: string | null;
  refund_payment_id: string | null;
  deleted_at: string | null;
  product: Product;
}

interface Product {
  id: number;
  token: string;
  price: number;
  product_tag: string;
  percorso_token: string;
  timer: number;
  links: Links;
  course_info: CourseInfo;
  // slides: string;
  tutoring: number;
  // weekly_hours: number;
  created_at: string;
  enable_quantity: boolean;
  hidden: number;
  updated_at: string;
  deleted_at: string | null;
  terms_cond_locales: string;
  detail_locales: string;
  files_locales: string;
}

interface Links {
  terms: string;
  policy: string;
}

interface CourseInfo {
  course_name: string;
  course_structure: CourseStructure[];
  months: number;
  link_onboarding: string;
  course_structure_week: CourseStructureWeek[];
}

interface CourseStructure {
  speaking: number;
  grammar: number;
  ielts: number;
  one_to_one: number;
}

interface CourseStructureWeek {
  speaking: number;
  grammar: number;
  ielts: number;
  one_to_one: number;
}

export interface UpsellingProp {
  inLastWeek: boolean;
  startDate: null | string;
  endDate: null | string;
  status: "PERMA_CLOSED" | "TEMP_CLOSED" | "ACCEPTED" | "NONE";
  shownDate: null | string;
  productId: null | number;
}

export interface Submission {
  questionId: number;
  selectedOptionId?: number;
  isCorrect: boolean;
  textAnswer?: string;
}

export interface NewResult {
  type: ExerciseOptionTypes;
  score: number;
  total: number;
}

export interface QuestionOption {
  explanation: string;
  id: number;
  multiple_choice_true_false_id: number;
  option: string;
  is_correct: number;
}

export interface Question {
  id: number;
  course_exercises_id: number;
  question: string;
  type: string;
  explanation: string | null;
  options: QuestionOption[];
}

export interface UserReports {
  data: UserReportData;
}

export interface UserReportData {
  class_id?: string;
  topic?: string;
  date?: string;
  time?: string;
  grammar?: FeedbackDetail[] | undefined;
  vocabulary?: FeedbackDetail[] | undefined;
  pronunciation?: FeedbackDetail[] | undefined;
}

export interface FeedbackDetail {
  student_name: string;
  mistake: string;
  feedback: string;
  explanation: string;
}

// ==============================================
// types for schedule speaking classes
// I intentionally ignored those defined above to avoid possible errors in case they have
// been used else where
// ==============================================

export interface ScheduleSpeakingClassesEvent {
  id: number;
  tutorToken: string;
  data: string;
  ora: string;
  oraFine: string;
  type: string;
  titolo: string;
  topic: string;
  descrizione: string;
  tutors: ScheduleSpeakingClassesTutor | null;
}

export interface ScheduleSpeakingClassesTutor {
  id: number;
  profilePic: string;
  first_name: string;
  last_name: string;
  token: string;
  role: string;
}

export interface ScheduleSpeakingClassesEvents {
  [date: string]: ScheduleSpeakingClassesEvent[];
}

export interface ScheduleSpeakingClassesPagination {
  currentPage: number;
  lastPage: number;
  totalPages: number;
}

export interface ScheduleSpeakingClassesAvailable {
  item: {
    original: {
      events: {
        [date: string]: ScheduleSpeakingClassesEvent[];
      };
      pagination: ScheduleSpeakingClassesPagination;
      remainingBookings: number;
      allowedBookingsPerWeek: number;
    };
  };
}
